import { useTranslation } from "@/shared/hooks";
import { getPhotoSectionsForLayout } from "@/shared/constants/layoutMapping";
import { PhotoUpload } from "../PhotoUpload";
import type { Image as ListingImage } from "@/shared/types/primitives";

interface PhotoSectionManagerProps {
  layout: string;
  imagesBySection?: Record<string, ListingImage[]>;
  onPhotosChange?: (sectionId: string, files: File[]) => void;
  onPhotoDelete?: (sectionId: string, imageUrl: string) => void;
  onPhotoReorder?: (sectionId: string, reorderedImages: ListingImage[]) => void;
  onToggleFeatured?: (sectionId: string, imageUrl: string) => void;
}

export function PhotoSectionManager({
  layout,
  imagesBySection = {},
  onPhotosChange,
  onPhotoDelete,
  onPhotoReorder,
  onToggleFeatured,
}: PhotoSectionManagerProps) {
  const t = useTranslation();
  const sections = getPhotoSectionsForLayout(layout);

  return (
    <div className="space-y-6">
      {sections.map((section) => (
        <div key={section.id}>
          <PhotoUpload
            sectionId={section.id}
            sectionLabel={t(section.labelKey as any)}
            images={imagesBySection[section.id] || []}
            onPhotosChange={(files) => onPhotosChange?.(section.id, files)}
            onPhotoDelete={(imageUrl: string) =>
              onPhotoDelete?.(section.id, imageUrl)
            }
            onPhotoReorder={(reorderedImages) =>
              onPhotoReorder?.(section.id, reorderedImages)
            }
            onToggleFeatured={(imageUrl: string) =>
              onToggleFeatured?.(section.id, imageUrl)
            }
            allImagesBySection={imagesBySection}
          />
        </div>
      ))}
    </div>
  );
}
